module.exports = require('./lib').default;
module.exports.default = module.exports;
module.exports.NextButton = require('./lib').NextButton;
module.exports.PreviousButton = require('./lib').PreviousButton;
module.exports.PagingDots = require('./lib').PagingDots;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/nuka-carousel/index.js
// module id = 731
// module chunks = 168707334958949